<template>
    <div :class="['app-auth-page', 'reg-bg']">
        <div id="components-section" data-aos="fade-left">
            <div id="sign-in-form-1">
                <div class="form-body">
                    <div class="level" style="display: flex">
                        <div class="level-item" style="flex-direction: column">
                            <div>
                                <p :class="{ error: error }">{{ $t(msg) }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VerifyEmail",
    data() {
        return {
            msg: "Verifying your Email...",
            error: false,
        };
    },
    methods: {
        verifyEmail(queryURL) {
            this.$store
                .dispatch("verifyEmail", queryURL)
                .then((res) => {
                    if (
                        res.status === 200 &&
                        this.$store.state.user.mobile_verified
                    ) {
                        this.$router.push({
                            name: "home",
                        });
                        return;
                    }
                    this.$router.push("/verify-mobile");
                })
                .catch((error) => {
                    this.msg =
                        "There was an error during this verifying your email, Please contact us";
                    this.error = true;
                });
        },
    },
    mounted() {
        if (
            this.$store.state.user.token &&
            this.$store.state.user.email_verified
        ) {
            return this.$router.push("/verify-mobile");
        }
        this.verifyEmail(this.$route.query.queryURL);
    },
};
</script>

<style lang="scss" scoped>
@import ".";
</style>
